<template>
  <vs-popup :active.sync="isStartComputationOpen" :title="title" :class="$style.container">

    <div class="vx-row" v-if="showMonth">
      <div class="vx-col w-full mb-3">
        <label class="vs-input--label pl-1">Месяц:</label>
        <datepicker
          v-model="selectedDate"
          class="w-full"
          format="MMMM yyyy"
          :minimumView="'month'"
          :maximumView="'year'"
        />
      </div>
    </div>

    <div v-if="heatSeason && (heatSeason.is_editable_start || heatSeason.is_editable_end)" :class="$style.notify">
      <feather-icon icon="AlertTriangleIcon" :svg-classes="$style.notifyIcon" />
      <div :class="$style.notifyText">
        <span v-if="heatSeason.is_editable_start">
          <span :class="$style.danger">Внимание!</span> Начало отопительного сезона: <b>{{ formatDate(heatSeason.period_start_month) }}</b> можно изменить на странице «Тарифы».
        </span>
        <span v-if="heatSeason.is_editable_end">
          <span :class="$style.danger">Внимание!</span> Окончание отопительного сезона: <b>{{ formatDate(heatSeason.period_end_month) }}</b> можно изменить на странице «Тарифы».
        </span>
        <router-link to="/uc/b/tariffs/0">Перейти</router-link>
      </div>
    </div>

    <div class="vx-row" v-if="showApartmentsTypes">
      <div class="vx-col w-full mb-3">
        <elsa-v-select
          :options="apartmentsTypes"
          v-model="computationParams.apartments_type"
          label="name"
          :reduce="item => item.id"
          :clearable="false"
          html-label="Тип помещений"
          style-type="largeLabel"
        />
      </div>
    </div>

    <template v-if="computationParams.calculate === false">
      <div class="vx-row">
        <template v-for="(constant, index) in constants">
          <div class="vx-col w-full mb-3" :key="index">
            <label>{{ constant.name }}</label>
            <vs-input
              class="w-full"
              @keypress="validateNumber"
              v-model="constant.value"
              :danger="constant.error"
              danger-text="Введите корректное значение"
              @change="constant.error=false"
            />
          </div>
        </template>
      </div>
    </template>

    <vs-collapse accordion :class="[$style.collapse, 'p-0']">
      <vs-collapse-item>
        <div slot="header">
          Доп. настройки
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <label class="vs-input--label">Не начислять норматив помещениям принятым после</label>
            <datepicker
              class="w-full"
              format="dd.MM.yyyy"
              v-model="computationParams.not_calculate_standard_month"
              id="newPayment-not_calculate_standard_month"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full flex">
            <vs-checkbox v-model="computationParams.is_heating" />
            <label class="vs-input--label">Относится ли прошлый месяц к отопительному периоду?</label>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>


    <div class="vx-row mt-4">
      <div class="vx-col w-full flex justify-center">
        <vs-button
          type="border"
          class="mb-2"
          @click="startComputation"
        >Начать расчет
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import quarterDisabledDates from "@/mixins/quarterDisabledDates";
import formatDate           from "@/client/helpers/formatDate";

export default {
  name:   "StartComputationPopup",
  mixins: [quarterDisabledDates],
  props:  {
    active:              {
      type:    Boolean,
      default: false,
    },
    buildingsId:         {
      required: true,
    },
    showMonth:           {
      type:    Boolean,
      default: false,
    },
    showApartmentsTypes: {
      type:    Boolean,
      default: false,
    },
    title:               {
      default: 'Как будет производиться расчет',
    },
  },
  data() {
    return {
      computationParams: {
        apartments_type:              null,
        calculate:                    false,
        is_heating:                   true,
        not_calculate_standard_month: null,
      },
      constants:         [],
      heatSeason:        null,
    };
  },
  computed: {
    selectedDate:           {
      get() {
        return this.$store.getters['appUser/selectedDate'];
      },
      set( value ) {
        this.$store.dispatch('appUser/SET_DATE', value);
      },
    },
    isStartComputationOpen: {
      get() {
        return this.active;
      },
      set( value ) {
        this.$emit("update:active", value);
      },
    },
    apartmentsTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },
    userId() {
      return this.$store.getters['appUser/id'];
    },
  },
  mounted() {
    this.updateSelectedApartmentsType();
  },
  methods: {
    formatDate,

    loadHeatSeason() {
      this.$http.get(`heat/season/current/${this.buildingsId}`, { params: { buildings_id: this.buildingsId } })
        .then(( { data: { season } } ) => this.heatSeason = season);
    },

    async resetComputationParams() {
      this.computationParams.calculate = false;
      this.computationParams.not_calculate_standard_month = null;
      this.computationParams.is_heating = true;

      try {
        let { data } = await this.$http.get('constants', {
          params: {
            buildings_id: this.buildingsId,
            changeable:   true,
          },
        });

        this.constants = this.restructureConstants(data);
      } catch (e) {
        console.error(e);
      }

      this.loadHeatSeason();
    },
    restructureConstants( data ) {
      let month = this.$options.filters.formatDate(this.selectedDate);
      let constants = [];
      data.forEach(c => {
        let value = null;
        let valueId = null;

        if (c.values) {
          if (c.values.hasOwnProperty(month)) {
            value = isNaN(parseFloat(c.values[month].value)) ? null : parseFloat(c.values[month].value);
            valueId = c.values[month].id;
          }
        }
        constants.push({
          id:           valueId,
          buildings_id: this.buildingsId,
          code:         c.code,
          name:         c.name,
          short_name:   c.short_name,
          types_id:     c.types_id,
          month:        month,
          value:        value,
          error:        false,
        });
      });

      constants.sort(( a, b ) => {
        if (a.types_id < b.types_id) {
          return -1;
        }
        if (a.types_id > b.types_id) {
          return 1;
        }
        return 0;
      });
      return constants;
    },
    validateNumber( e ) {
      let keyCode = e.which ? e.which : e.keyCode;
      if (!((keyCode >= 48 && keyCode <= 57) || keyCode === 46 || keyCode === 44 || keyCode === 45)) {
        e.preventDefault();
      }
    },
    checkComputationParamsHasErrors() {
      for (let error in this.constants) {
        if (this.constants.hasOwnProperty(error)) {
          if (this.constants[error].error === true) return true;
        }
      }
      return false;
    },
    saveConstants( constants ) {
      return Promise.all(constants.map(constant => {
        if (constant.id) {
          if (constant.value !== null) {
            return this.updateConstant(constant);
          } else {
            return this.deleteConstant(constant);
          }
        } else {
          if (constant.value !== null) {
            return this.createConstant(constant);
          }
        }
      }));
    },
    createConstant( constant ) {
      return new Promise(async ( resolve, reject ) => {
        try {
          let body = {
            value:        constant.value,
            name:         constant.name,
            short_name:   constant.short_name,
            buildings_id: constant.buildings_id,
            purpose:      "formula",
            month:        constant.month,
          };

          if (constant.code) {
            body.code = constant.code;
            body.types_id = constant.types_id;
          } else {
            body.types_id = 5;
          }

          let { data } = await this.$http.post('constants', body);
          resolve(data);
        } catch (e) {
          reject(e);
        }
      });
    },
    updateConstant( constant ) {
      return new Promise(async ( resolve, reject ) => {
        try {
          let body = {
            value:        constant.value,
            name:         constant.name,
            short_name:   constant.short_name,
            buildings_id: constant.buildings_id,
            id:           constant.id,
          };
          let { data } = await this.$http.put('constants/' + constant.id, body);
          resolve(data);
        } catch (e) {
          reject(e);
        }
      });
    },
    deleteConstant( constant ) {
      return new Promise(async ( resolve, reject ) => {
        try {
          await this.$http.delete('constants/' + constant.id, { params: { buildings_id: constant.buildings_id } });
          resolve(true);
        } catch (e) {
          reject(e);
        }
      });
    },
    async startComputation() {
      if (this.computationParams.calculate === false) {
        this.constants.forEach(constant => {
          if (constant.value !== null) {
            let val = String(constant.value);
            val = val.replace(/,/g, '.');
            if (val.length) {
              if (isNaN(Number(val))) {
                constant.error = true;
              } else {
                constant.value = val;
              }
            } else {
              constant.value = null;
            }
          }
        });
        if (this.checkComputationParamsHasErrors()) return false;
      }
      await this.saveConstants(this.constants);

      let params = {
        buildings_id:                 this.buildingsId,
        month:                        this.$options.filters.formatDate(this.selectedDate),
        who:                          this.userId,
        calculate:                    this.computationParams.calculate,
        not_calculate_standard_month: this.computationParams.not_calculate_standard_month,
        apartments_type:              this.computationParams.apartments_type,
        is_heating:                   this.computationParams.is_heating,
      };
      this.isStartComputationOpen = false;
      this.$emit('startComputation', params);
    },
    updateSelectedApartmentsType() {
      if (this.apartmentsTypes.length >= 1) {
        this.computationParams.apartments_type = this.apartmentsTypes[0].id;
      }
    },
  },
  watch:   {
    selectedDate() {
      this.resetComputationParams();
    },
    apartmentsTypes() {
      this.updateSelectedApartmentsType();
    },
    isStartComputationOpen() {
      if (this.isStartComputationOpen) {
        this.resetComputationParams();
      }
    },
  },
};
</script>

<style lang="scss" module>
.container {
  :global(.vs-popup) {
    width: 480px;
  }
}

.collapse {
  :global(.vs-collapse-item--header) {
    padding-left: 5px;
    font-size: 1rem;
    border-top: 1px solid #f2f2f2;
  }

  :global(.vs-collapse-item--content) {
    :global(.con-content--item ) {
      padding: 5px !important;
    }
  }
}

.notify {
  display: flex;
  margin-bottom: 1em;
  //padding: 0 1rem;
}

.notifyIcon {
  color: color(danger);
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  margin-right: .5em;
}

.danger {
  font-weight: 500;
  color: color(danger);
}

</style>
